
<v-dialog
    v-model    = "value"
    transition = "dialog-bottom-transition"
    fullscreen
    hide-overlay
    persistent
    no-click-animation
>
    <div class="white" style="margin-top: 6px; width: calc(100% - 65px); ">
        <f-dialog-title
            title   = "INBOX"
            @cancel = "onCancel"
            style   = "border-radius: 4px;margin-left: 75px;"
        />

        <div class="mt-2 content">
            <v-row class="no-frame">
                <v-col class="no-frame col-6 pr-1">
                    <div class="w-100 v-flex" style="height: 30px;">
                        <div class="folder-tab v-tab folder-tab-active primary" style="border-bottom-width: 1px">Mail / Anhang</div>
                    </div>

                    <div class="w-100 white mt-1" style="height: calc(100% - 35px)">
                        <c-dms-viewer
                            :document = "document"
                        />
                    </div>
                </v-col>
                <v-col class="no-frame col-6 pl-1">
                    <div class="w-100 v-flex">
                        <div class="folder-tab v-tab folder-tab-active primary" style="border-bottom-width: 1px">Inhalt</div>
                        <v-spacer />
                        <c-inbox-attachment-menu
                            :attachment   = "attachment"
                            :zoom-allowed = "false"
                            @save         = "onSave"
                            @close        = "onClose"
                            @create       = "onCreate"
                            @creategoto   = "onCreateAndGoto"
                        />
                    </div>

                    <c-inbox-detail
                        :attachment = "attachment"
                        :height     = "height-30"
                        @changed    = "onChanged"
                        @context    = "onContext"
                        @morph      = "onMorph"
                        ref         = "message"
                        class       = "mt-1"
                    />
                </v-col>
            </v-row>
        </div>
    </div>
</v-dialog>
